import { Reveal, ChapterTag } from "./motion";
import { Infinity as InfinityIcon, Sparkles, Home, RotateCcw } from "lucide-react";

const ITEMS = [
  { icon: InfinityIcon, title: "No refills", desc: "Forget about constantly buying sticky refill rolls." },
  { icon: Sparkles, title: "Self-cleaning", desc: "The hair is collected inside the compartment." },
  { icon: Home, title: "For the whole house", desc: "Sofa, bed, clothes, cushions and car." },
  { icon: RotateCcw, title: "Reusable", desc: "Use it over and over again." },
];

export const Benefits = () => (
  <section id="beneficios" data-testid="benefits-section" className="py-16 sm:py-24 lg:py-32">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <ChapterTag num="04" label="Benefits" />
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-balance">
          Built to last. Designed for your home.
        </h2>
      </Reveal>
      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
        {ITEMS.map((item, i) => (
          <Reveal key={item.title} delay={i * 0.1}>
            <div
              data-testid={`benefit-card-${i}`}
              className="h-full rounded-2xl border border-zinc-100 bg-white p-6 sm:p-8 hover:border-brand/40 hover:shadow-lg hover:shadow-brand/5 transition-all duration-300"
            >
              <span className="w-11 h-11 rounded-xl bg-brand-soft flex items-center justify-center mb-5">
                <item.icon className="w-5 h-5 text-brand" />
              </span>
              <h3 className="font-display font-semibold text-lg">{item.title}</h3>
              <p className="mt-2 text-sm text-zinc-500 leading-relaxed">{item.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
